import React, { Component, createRef } from 'react'

import { delay } from 'rxjs/operators'

import { submitPasswordReset } from 'services/SessionService'
import Icon from 'components/shared/Icon'
import notificationToast from 'helpers/notificationToast'
import CheckIcon from '@material-ui/icons/CheckCircle'
import { toast } from 'react-toastify'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

export default class PasswordResetOverlay extends Component {
  constructor (props) {
    super(props)
    this.oldPasswordRef = createRef()
    this.newPasswordRef = createRef()
    this.repeatPasswordRef = createRef()
  }

  state = {
    oldPassword: '',
    newPassword: '',
    repeatPassword: '',
    errorMessage: null,
    submitting: false
  }

  handleFormSubmit = (e) => {
    const { oldPassword, newPassword, repeatPassword } = this.state
    const { setOpenPasswordResetModal } = this.props

    e.preventDefault()

    if (!oldPassword) {
      this.oldPasswordRef.current.focus()
      return this.setState({ errorMessage: 'Please enter your old password.' })
    }

    if (newPassword.match(' ') !== null) {
      this.newPasswordRef.current.focus()
      return this.setState({ errorMessage: 'Please try again. Your password cannot contain spaces.' })
    }

    if (newPassword.length < 8) {
      this.newPasswordRef.current.focus()
      return this.setState({ errorMessage: 'Please try again. Your password must be longer than 8 characters.' })
    }

    if (newPassword !== repeatPassword) {
      this.repeatPasswordRef.current.focus()
      return this.setState({ errorMessage: 'Please try again. Your password entries do not match.', repeatPassword: '' })
    }

    this.setState({ submitting: true })

    submitPasswordReset({
      oldPassword,
      newPassword,
      mail: this.props.email
    })
      .pipe(delay(1000))
      .subscribe(({ success }) => {
        if (!success) {
          this.setState({ submitting: false, errorMessage: 'Please try again. Your old password does not match what we have in our system.', oldPassword: '' })
          this.oldPasswordRef.current.focus()
        } else {
          notificationToast(<CheckIcon />, toast.TYPE.SUCCESS, 'Password changed successfully', 'bg-dark-sea-green')
          this.setState({ submitting: false })
          setOpenPasswordResetModal(false)
          this.resetInputFields()
        }
      })
  }

  renderInput (name, ref, autofocus = false) {
    return (
      <input
        className='w-65 w-100-m h3 ma0 f5'
        autoFocus={autofocus}
        type='password'
        ref={ref}
        value={this.state[name]}
        onChange={({ target: { value } }) => this.setState({ [name]: value, errorMessage: null })}
      />
    )
  }

  resetInputFields () {
    this.setState({ oldPassword: '', newPassword: '', repeatPassword: '' })
  }

  render () {
    const { email, openPasswordResetModal, setOpenPasswordResetModal } = this.props
    const { errorMessage, submitting } = this.state
    const handleOnCancelClick = () => {
      setOpenPasswordResetModal(false)
      this.resetInputFields()
    }

    return (
      <Dialog
        fullWidth
        maxWidth='md'
        open={openPasswordResetModal}
        onClose={handleOnCancelClick}
        className='pb6'
      >
        <DialogTitle id='pb4 f3 bb b--phantom-grey'>Reset password</DialogTitle>
        <DialogContent>
          <form id='resetPasswordForm' className='min-h-spacing-14 flex flex-column justify-around' onSubmit={this.handleFormSubmit}>
            <div className='flex flex-column-m justify-between items-center'>
              <span className='ds'>Email</span>
              <input className='w-65 w-100-m h3 ma0 f5' type='text' value={email} disabled />
            </div>
            <div className='flex justify-between items-center'>
              <span className='ds'>Old password</span>
              {this.renderInput('oldPassword', this.oldPasswordRef, true)}
            </div>
            <div className='flex justify-between items-center'>
              <span className='ds'>New password</span>
              {this.renderInput('newPassword', this.newPasswordRef)}
            </div>
            <div className='flex justify-between items-center'>
              <span className='ds'>Repeat new password</span>
              {this.renderInput('repeatPassword', this.repeatPasswordRef)}
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          {errorMessage && (
            <div className='mt6 mb4 tc crimson'>
              <Icon name='icon-alert-circle' /> {errorMessage}
            </div>
          )}
          {submitting && (
            <div>
              <Icon name='icon-clock' /> Submitting
            </div>
          )}
          {!submitting && (
            <div className='mt6 tr'>
              <button
                type='submit'
                className='bg-teal white hover-white pv3 ph5 ba b--transparent br2 normal f6 lh-copy-variant hover-o-90 pointer'
                form='resetPasswordForm'
              >
                Submit
              </button>
              <button
                type='reset'
                onClick={handleOnCancelClick}
                className='bg-void-grey black pv3 ph5 ba b--transparent br2 normal f6 lh-copy-variant hover-o-90 ml6 pointer'
                form='resetPasswordForm'
              >
                Cancel
              </button>
            </div>
          )}
        </DialogActions>
      </Dialog>
    )
  }
}

PasswordResetOverlay.disableOutsideToggle = true
